{
  "alert": "Upozorenje",
  "dismiss": "Odbaci"
}